import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./taskForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputText,
  InputSelect,
  InputCheck,
  BreadCrumb,
  InputTextarea,
} from "@de-prado-dev/react-component-library";
import { CULTURES } from "../../../../constants/index";

const TaskForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleSubmit, onback, edit } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.task.title"), path: PATHS.TASK_LIST },
    { label: t("forms.task.new") },
  ];

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.task.titleEdit") : t("forms.task.titleNew")}
          </h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-5">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="code"
                  className="form-control"
                  labelField={t("forms.task.labels.code")}
                  name="code"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="name"
                  className="form-control"
                  labelField={t("forms.task.labels.name")}
                  name="name"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="namePt"
                  className="form-control"
                  labelField={t("forms.task.labels.namePt")}
                  name="namePt"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="performance"
                  className="form-control"
                  labelField={t("forms.task.labels.performance")}
                  name="performance"
                  placeholder=""
                  component={InputText}
                  fieldType="number"
                  mandatory
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-2">
                <Field
                  id="culture"
                  name="culture"
                  labelField={t("forms.task.labels.culture")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="code"
                  options={CULTURES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  addOptionEmpty
                  classNamePrefix="dark"
                  mandatory
                />
              </div>
            </div>
            <div className="row  mt-3">
              <div className="col-3">
                <Field
                  id="active"
                  labelField={t("forms.task.labels.active")}
                  name="active"
                  placeholder=""
                  component={InputCheck}
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="description"
                  className="form-control"
                  labelField={t("forms.task.labels.description")}
                  name="description"
                  placeholder=""
                  component={InputTextarea}
                  rows={5}
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.task.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.task.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

TaskForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const TaskFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "TaskForm",
})(TaskForm);

export default TaskFormF;
